import { useDispatch } from 'react-redux'
import { AICard } from 'components'
import { setDrawer } from 'slices/drawer'
import {
  DRAWER_KEY,
  SUPPORT_STATUS,
  SUPPORT_STATUS_CTA_LABEL,
  SUPPORT_STATUS_TITLE,
} from 'app-constants'
import { STATICS } from 'statics'
import './style.scss'

export function ScheduleRepair({ data }) {
  const { detailedMessage } = data
  const dispatch = useDispatch()

  function handleScheduleClick() {
    dispatch(setDrawer(DRAWER_KEY.VIRTUAL_SUPPORT))
  }

  function renderIcon() {
    return (
      <div className='icon'>
        <STATICS.INFO_TRIANGLE_FILLED />
      </div>
    )
  }

  return (
    <div className='schedule-repair'>
      <AICard
        title={SUPPORT_STATUS_TITLE[SUPPORT_STATUS.SCHEDULE_REPAIR]}
        message={detailedMessage}
        ctaLabel={SUPPORT_STATUS_CTA_LABEL.SCHEDULE}
        onCtaClick={handleScheduleClick}
        icon={renderIcon()}
      />
    </div>
  )
}
